import { Injectable } from "@angular/core";
import { KeyValue } from "../../models/keyValue.model";
import { AppSqlProvider } from "../../persistence/app.sql.provider";
import { LoggerService } from "../../services/logs/logger.service";
import { DbDaoBase } from "./base/db.dao.base";

@Injectable({
    providedIn: "root",
})
export class KeyValueDbDao extends DbDaoBase<KeyValue> {
    constructor(logger: LoggerService,
                private sqlProvider: AppSqlProvider) {
        super(logger);
    }

    public getTableName(): string {
        return KeyValue.TABLENAME;
    }

    public get(key: string, hydrate: boolean = false): Promise<KeyValue> {
        let selectQuery = "SELECT * FROM " + KeyValue.TABLENAME + " WHERE key = '" + key + "';";

        return this.sqlProvider.query(selectQuery)
            .then(data => {
                if (data.rows.length <= 0) {
                    return null;
                }

                return this.rowToModel(data.rows[0]);
            })
            .catch(reason => {
                this.logSqlError(reason);
                return null;
            });
    }

    deleteAll(): Promise<any> {
        let selectQuery = "DELETE FROM " + KeyValue.TABLENAME + ";";
        return this.sqlProvider.query(selectQuery);
    }

    delete(key: string): Promise<any> {
        let selectQuery = "DELETE FROM " + KeyValue.TABLENAME + " WHERE key='" + key + "';";
        return this.sqlProvider.query(selectQuery);
    }

    public save(keyValue: KeyValue): Promise<KeyValue> {
        let query = "INSERT OR REPLACE INTO " + KeyValue.TABLENAME + " (key, value) VALUES ("
                    + this.getValue(keyValue.key)
                    + this.getValue(keyValue.value, true)
                    + ");";

        return this.sqlProvider.query(query)
            .then(response => {
                return keyValue;
            })
            .catch(reason => {
                this.logSqlError(reason);
                return null;
            });
    }

    public createTable(): Promise<void> {
        let query = "CREATE TABLE IF NOT EXISTS " + KeyValue.TABLENAME
                    + " ("
                    + "key TEXT PRIMARY KEY,"
                    + "value TEXT"
                    + ");";

        return this.sqlProvider.query(query)
            .then(async () => {
                await this.createIndexes();
                return;
            })
            .catch(reason => {
                this.logSqlError(reason);
                return null;
            });
    }

    public async createIndexes(): Promise<void> {
        let query = "CREATE INDEX IF NOT EXISTS idx_" + KeyValue.TABLENAME + "_key"
                    + " ON " + KeyValue.TABLENAME + "(key);";

        await this.sqlProvider.query(query)
            .catch(reason => {
                this.logSqlError(reason);
            });
    }

    protected rowToModel(row: any): KeyValue {
        return new KeyValue(row.key, row.value);
    }
}
